/*eslint-disable*/

import * as types from './mutation-types'
import $Cookies from 'js-cookie';

const mutations = {
  [types.SET_NAV_INDEX](state,navIndex){
    state.navIndex = navIndex;
  },
  [types.SET_MINE_NAV_INDEX](state,nowIndex){
    state.mineNavIndex = nowIndex;
  },
  [types.SET_SLOTS_NAV_INDEX](state,nowIndex){
    state.slotsNavIndex = nowIndex;
  },
  [types.SET_MINE_CAPITAL_NAV](state,nowIndex){
    state.mineCapitalNavIndex = nowIndex;
  },
  [types.SET_HELP_CAPITAL_NAV](state,nowIndex){
    state.helpCenterNavIndex = nowIndex;
  },
  // 收藏
  [types.SET_SLOT_COLLECTION](state,mySlot) {
    state.mySlot = mySlot
  },
  // 登录
  [types.LOGIN](state,UUID){
    state.isLogin = true;
    state.UUID = UUID;
  },
  // 登录
  [types.CHECK_LOGIN](state,obj){
    state.isLogin = obj.isLogin;
    state.UUID = obj.UUID;
  },
  // 用户信息
  [types.SET_USER_INFO](state,info){
    state.userInfo = info;
  },
  // 清除登录状态
  [types.LOGIN_OUT](state){
    if (state.isLogin) {
      $Cookies.remove('UUID')
      $Cookies.remove('agentCode')
    }
    state.isLogin = false;
    state.UUID = '';
    state.mySlot = [];
    state.userInfo = {
      userInfo: {
        userAccount: '',
        withdrawPasswordValid: '',
        nameValid: '',
        mobileValid: '',
        emailValid: '',
        status: '',
        level: 1,
        mobilePhone: '',
        name: null,
      },
      offerNumberMap: {
        applyingNumber: 0,
        processingNumber: 0,
        receivedNumber: 0,
        waitReceiveNumber: 0
      },
      msgNumber: 0,
      assetsInfoMap: {
        AvailBalance: '',
        accountBalance: '',
        gameAccountList: [],
        mainBalance: '',
      },
      serverInfo: {
        payDomain: '',
        withdrawMethod: ''
      },
      userCountInfo: {
        totalWithdraw: '',
        totalBonus: ''
      },
      vipInfo: {
        vipName: ''
      }
    }
  },
  // 首页广告
  [types.CLOSE_INDEX_AD](state){
    state.isShowIndexAD = false;
  },
  set_CLOSE_INDEX_AD(state,fool=false){
    state.isShowIndexAD = fool;
  },


  setADCloseNum(state,num){
    if(num==0){
      state.indexADCloseNum = num;
    }else{
      state.indexADCloseNum += num;
    }
   
  },
  // 链接
  [types.INIT_LIST](state,linkList) {
    state.linkList = linkList
  },
  // 新链接
  [types.FRONTCONFIG_LIST](state,linkList) {
    // state.newlinkList = linkList
    if(linkList){
      let obj = {};
      linkList.map((item) => {
        obj[item.configKey] = item.configVal;
      });
      state.FrontConfigList = obj;
    }
  },
  // 设置维护列表
  [types.SET_MAINTAIN_GAME_LIST](state,list) {
    state.maintain_game_platform_list = list
  },
  // 设置维护信息
  [types.SET_MAINTAIN_GAME_INFO](state,info) {
    state.maintain_game_info = info
  },
  // 设置维护信息状态
  [types.SET_MAINTAIN_GAME_STATE](state,boolean) {
    state.maintain_game_state = boolean
  },
  // 设置站内信条数
  [types.SET_INEMAIL](state,num){
    state.inEmailNoRead = num
  },
  // 老虎机游戏图片链接
  [types.SET_SLOT_PIC](state,picLink){
    state.picLink = picLink
  },

  set_downNav(state,obj) {
    state.downNav = obj
  },
  add_startMoney(state,num) {
    state.startMoney += num
  },
  // 设置一级导航
  [types.SET_FIRST_NAV](state, nav) {
    state.firstNav = nav
  },

  setFirstNav(state,obj) {
    state.firstNav = obj
  },

  TOP_VIEW() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  SET_VIEW() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  // 设置各游戏平台
  [types.GAME_LIST_BY_PLATFORM] (state, obj) {
    state[obj.name] = obj.list
  },

  // 多彩宝
  // 一级路由
  SET_COLOR_INDEX(state,index) {
    state.colorNavIndex = index
  },

  [types.SET_COLOR_SERVICE](state,url) {
    state.COLOR_SERVICE = url
  },

  [types.ADD_COLOR_STARTMONEY](state,num) {
    state.colorStartMoney += num
  },

  // 金色版
  SET_GOLD_NAVINDEX(state,index) {
    state.goldNavIndex = index
  },
  [types.SET_ARTICLETYPELIST](state, list) {
    state.articleTypeList = list
  },
  SET_ISREGISTERPAGE(state,boolean) {
    state.isRegisterPage = boolean
  },

  // 金沙
  // 进入游戏登陆框
  [types.JIN_SHA_GLOBAL_LOGIN](state,boolean) {
    state.jin_sha_global_login_state = boolean
  },
  // 登录前选择的游戏
  [types.BEFORE_LOGIN_GAME_INFO](state,obj) {
    state.before_login_game_info = obj
  },
  // 是否登陆框是否需要聚焦
  [types.IS_LOGIN_FOCUS](state,bool) {
    state.is_login_focus = bool
  },

  // 体育
  [types.SPORTS_SET_TOP_NAV](state,bool) {
    state.isAtSportsPage = bool
  },
  [types.SET_SPORTS_NAV_INDEX](state, index) {
    state.sports_nav_index = index
  },
  [types.SET_IS_REGISTER_SUCCESS](state, boolean) {
    state.is_register_success = boolean
  },
  // 新优惠
  [types.SETBONUSTYPES](state, array) {
    state.BonusTypes = array
  },
   // 获取所有优惠
   setAllBonusArticle(state,array){
    state.allBonusArticle = array
  },
  // 实名认证开关
  setIsNameVerify(state,bool){
    state.isNameVerify = bool
  },
  // 手机认证开关
  setIsPhoneVerify(state,bool){
    state.isPhoneVerify = bool
  },
  // 邮箱认证开关
  setIsMailVerify(state,bool){
    state.isMailVerify = bool
  },
  // 存款滚动距离
  setScrollRange(state,num){
    state.scrollRange = num
  },

  // 未登录登录弹框
  setShowLoginBox(state,bool){
    state.showLoginBox = bool
  },
  // 未登录登录弹框1
  setshowloginfloat(state,bool){
    state.showloginfloat = bool
  },
  // 未登录登录弹框2
  setshowloginfloat2(state,bool){
    state.showloginfloat2 = bool
  },
  // 绑定手机
  setshowBindphone(state,bool){
    state.showBindphone = bool
  },
  // 未登录框显示组件
  // loginFloat,registerFloat
  setShowLoginBoxName(state,string){
    state.showLoginBoxName = string
  },
  // 设置语言
  setIsLanguage(state,string){
    state.isLanguage = string
  },
  // 公告栏控制
  setTableVisible(state,boolean){
    state.dialogTableVisible = boolean
  },
  // 设置忘记密码显示
  setShowPassword(state,bool){
    state.showPassword = bool
  },
  // 设置所有游戏
  setAllGame(state,obj){
    state.allGameList = obj
  },
  setInviteInfo(state, data){
    state.inviteInfo = data
  },
  SET_FORCE_CHANGE_PASSWORD(state, value) {
    state.forceChangePassword = value;
  }
};
export default mutations



// WEBPACK FOOTER //
// ./src/common/store/mutations.js